























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import VCheckBox from "@/components/VCheckbox.vue";

export type TwoStagesSelectItems = {
  id: string;
  selected: boolean;
  text: string;
};

export type TwoStagesSelectGroup = {
  id: string;
  text: string;
  count: number;
  items: TwoStagesSelectItems[];
};

export type TwoStagesModel = {
  selectedGroupId: string | null;
  groups: TwoStagesSelectGroup[];
};

const TwoStagesSelectFirstStage = "first_stage";
const TwoStagesSelectSecondStage = "second_stage";

export type TwoStagesSelectStage =
  | typeof TwoStagesSelectFirstStage
  | typeof TwoStagesSelectSecondStage;

const TwoStagesSelectOpenedStatus = "opened";
const TwoStagesSelectClosedStatus = "closed";

export type TwoStagesSelectStatus =
  | typeof TwoStagesSelectOpenedStatus
  | typeof TwoStagesSelectClosedStatus;

@Component({ components: { VCheckBox } })
export default class TwoStagesSelect extends Vue {
  @Prop({ required: true }) readonly label!: string;
  @Prop({ required: true }) readonly value!: TwoStagesModel;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: "Opzioni" }) readonly firstStageTitle!: string;
  @Prop({ default: "200px" }) readonly menuHeight!: string;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly allowNoSelection!: boolean;

  private stage: TwoStagesSelectStage = TwoStagesSelectFirstStage;
  private status: TwoStagesSelectStatus = TwoStagesSelectClosedStatus;

  private model: TwoStagesModel = {
    selectedGroupId: null,
    groups: [],
  };

  get selectedGroup(): TwoStagesSelectGroup | null {
    if (this.model.selectedGroupId !== null) {
      return (
        this.model.groups.find((e) => e.id === this.model.selectedGroupId) ||
        null
      );
    }
    return null;
  }

  get isOpened() {
    return this.status === TwoStagesSelectOpenedStatus;
  }

  get isFirstStage() {
    return this.stage === TwoStagesSelectFirstStage;
  }

  get isSecondStage() {
    return this.stage === TwoStagesSelectSecondStage;
  }

  get humanReadable() {
    const selectedId = this.value.selectedGroupId;
    if (selectedId) {
      const selected = this.value.groups.find((group) => {
        return group.id === selectedId;
      });
      if (selected) {
        return `${selected?.text} (${selected?.count})`;
      }
    }
    return "";
  }

  get canApply() {
    return this.allowNoSelection || !!this.selectedGroup?.count;
  }

  @Watch("value", { deep: true })
  onValueChanged(value: TwoStagesModel) {
    if (value === null || value.selectedGroupId === null) {
      this.stage = TwoStagesSelectFirstStage;
    } else {
      this.stage = TwoStagesSelectSecondStage;
    }
    this.loadModel();
  }

  mounted() {
    this.loadModel();
  }

  loadModel() {
    this.model = JSON.parse(JSON.stringify(this.value));
  }

  onInputClick() {
    this.loadModel();
    if (this.selectedGroup?.count || 0 > 0) {
      this.stage = TwoStagesSelectSecondStage;
    } else {
      this.stage = TwoStagesSelectFirstStage;
    }
    this.status = TwoStagesSelectOpenedStatus;
  }

  onClickOutside() {
    this.closeMenu(true);
  }

  onGroupClick(group: TwoStagesSelectGroup) {
    if (group.id !== this.model.selectedGroupId) {
      this.onResetClicked();
    }
    this.model.selectedGroupId = group.id;
    this.stage = TwoStagesSelectSecondStage;
    this.$emit("group", group, this.model);
  }

  onBackClicked() {
    this.stage = TwoStagesSelectFirstStage;
  }

  onResetClicked() {
    this.model.selectedGroupId = null;
    this.model.groups.forEach((group) => {
      group.count = 0;
      group.items.forEach((item) => {
        item.selected = false;
      });
    });
    this.stage = TwoStagesSelectFirstStage;
  }

  onSelectAllClicked() {
    const group = this.selectedGroup;
    if (group) {
      group.items.forEach((item) => {
        item.selected = true;
      });
      group.count = group.items.length;
    }
  }

  onItemSelectToggle(item: TwoStagesSelectItems) {
    item.selected = !item.selected;
    if (this.selectedGroup) {
      if (item.selected) {
        this.selectedGroup.count++;
      } else {
        this.selectedGroup.count--;
      }
    }
  }

  onApplyClicked() {
    this.$emit("input", this.model);
    this.closeMenu();
  }

  private closeMenu(notify?: boolean) {
    this.status = TwoStagesSelectClosedStatus;
    if (notify) {
      this.$emit("closed");
    }
  }
}
